.root {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  overflow: auto;
}

.nav {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.emptyState {
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.contentLayout {
  padding-bottom: 56px;
  margin: 0;
  width: 100%;
  padding: 0;
}

.splitter {
  position: relative;
  display: flex;
  flex: 1;
  overflow: auto;
  padding-bottom: 64px;
  padding: 16px;
}

/*
 * Stable content/sidebar layout. Content always lives in `.contentPane` so its
 * subtree (the editor) is never re-parented when the sidebar toggles — toggling
 * the sidebar only adds or removes the `.sidebarPane` sibling. This avoids
 * remounting the editor and the page-blank-on-toggle reload.
 */
.contentRow {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: row;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 64px;
}

.contentPane {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  overflow: auto;
  padding: 16px;
}

/*
 * Phones: the default-part notice sits above the bottom bar (48px targets plus padding and border), which is
 * itself fixed above the page navigation (56px plus the safe area). Otherwise the navigation covers the notice
 * and its "Change for this band" action cannot be tapped. `.root` outranks the Snackbar's own `bottom`.
 */
@media (max-width: 599.95px) {
  .root .defaultPartNotice {
    bottom: calc(
      56px + env(safe-area-inset-bottom, 0px) + var(--tuna-spacing-6) + var(--tuna-spacing-1) + var(--tuna-spacing-1)
    );
  }
}

/* Phones (GH #1553): no side inset, so chords and lyrics use the full width */
.contentPane--tiny {
  padding-left: 0;
  padding-right: 0;
  /* Room for the bottom bar (48px targets plus padding) above the page navigation */
  padding-bottom: calc(var(--tuna-spacing-6) + var(--tuna-spacing-1));
}

.sidebarPane {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  min-width: 0;
  overflow: auto;
  padding: 16px;
}

.sidebar {
  flex: 1;
  padding-bottom: 32px;
}

.progressBar {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 3px;
  background: var(--tuna-palette-grey-200);
  flex-shrink: 0;
}

.progressFill {
  height: 100%;
  background: var(--tuna-palette-primary-main);
  transition: width 0.3s linear;
}

/*
 * Mobile drawer for the notes panel at narrow viewports (<600px).
 * - Safe-area inset for iOS notches and home-indicator.
 * - Scrollable content area; the panel itself can be tall.
 * - Sits above the fixed performance navigation (z-index 1) but below modal popups.
 */
.mobileDrawer {
  padding: 12px 12px calc(env(safe-area-inset-bottom, 0px) + 64px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
  box-shadow: 0 -4px 16px color-mix(in oklch, var(--tuna-shadow-color) 12%, transparent);
}
